import FormTitle from '@/view/weappTmp/comps/title/index.vue'
import { ElementNode } from '@/view/weappTmp/core/lib/package/element-node.js'
export default {
  components: {
    FormTitle
  },
  data () {
    return {
      _target: {},
    }
  },
  props: {
    props: ['value'],
    target: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    quoteKey: {
      type: String,
      default: ''
    },
    element__this: {
      type: Object,
      default: () => {
        return {}
      }
    },
    v_key: {
      type: String,
      default: ''
    }
  },
  destroyed () {
    // console.log('父级',this.pedestalId,'实例销毁')
    // this.element__this = null
  },
  created () { },
  mounted () {
    console.log('element-node-mixin -key', this.element__this.key)
    console.log('element-node-mixin ', this)
    // 如果是通过配置初始化,必定会有pid
    if(this.element__this.pid) this.element__this.VMNative(this)
    // 否则就是直接引用,那么使用 _VMNative 进行响应式关联;
    else ElementNode._VMNative(this)
  },
  
}
